"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorRenewalReplaceCarPriceWidget = void 0;
var React = require("react");
var FalconQuestionWidgetBase_1 = require("../../../../FalconQuestionWidgetBase");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../../../commonFunctions");
var AnnualMotorRenewalReplaceCarPriceWidget = exports.AnnualMotorRenewalReplaceCarPriceWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorRenewalReplaceCarPriceWidget, _super);
    function AnnualMotorRenewalReplaceCarPriceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.setSessionValues = function (renewalProposal) {
            var oldVehicleMake = _this.findOldVehicleProperty(renewalProposal, "make");
            var oldVehicleModel = _this.findOldVehicleProperty(renewalProposal, "model");
            var oldVehicleRegistrationNumber = _this.findOldVehicleProperty(renewalProposal, "registrationNumber");
            window.sessionStorage.setItem("oldCarVrn", oldVehicleRegistrationNumber);
            window.sessionStorage.setItem("oldCarMake", oldVehicleMake);
            window.sessionStorage.setItem("oldCarModel", oldVehicleModel);
        };
        _this.findOldVehicleProperty = function (renewalProposal, propertyName) {
            return renewalProposal.vehicles[0][propertyName];
        };
        _this.state = {
            oldInteraction: {},
            loaded: false,
            oldVehicle: {},
            newVehicle: {}
        };
        return _this;
    }
    AnnualMotorRenewalReplaceCarPriceWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getRenewalProposal(this.props.interaction.agreementNumber).subscribe(function (renewalProposal) {
            _this.setState({
                oldInteraction: renewalProposal,
                loaded: true,
                oldVehicle: renewalProposal.vehicles[0],
                newVehicle: _this.props.engine.getInteraction().vehicles[0]
            });
            _this.setSessionValues(renewalProposal);
        });
    };
    AnnualMotorRenewalReplaceCarPriceWidget.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps !== this.props) {
            this.setState({ newVehicle: this.props.engine.getInteraction().vehicles[0] });
        }
    };
    AnnualMotorRenewalReplaceCarPriceWidget.prototype.render = function () {
        var _a, _b;
        if (!((_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.oldInteraction) === null || _b === void 0 ? void 0 : _b.vehicles) && this.state.loaded) {
            throw Error("".concat(this.props.question.type, " widget could not find the previous vehicle"));
        }
        return (React.createElement("div", { className: "panel policy-change-price" }, this.renderNewPriceWording()));
    };
    AnnualMotorRenewalReplaceCarPriceWidget.prototype.renderNewPriceWording = function () {
        var _a, _b, _c;
        var newFactors = (_a = this.props.interaction) === null || _a === void 0 ? void 0 : _a.factors;
        var oldVehicle = (_b = this === null || this === void 0 ? void 0 : this.state) === null || _b === void 0 ? void 0 : _b.oldVehicle;
        var newVehicle = (_c = this === null || this === void 0 ? void 0 : this.state) === null || _c === void 0 ? void 0 : _c.newVehicle;
        var tierChangeWording = (0, commonFunctions_1.getTierChangeWording)(this.props.interaction);
        return (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "text-align-center" },
                "Your next year's renewal price will be ",
                React.createElement("span", { className: "font-weight-bold" },
                    (0, commonFunctions_1.getAmountToDisplay)(newFactors.annualPremium) + " ",
                    " "),
                "after replacing ", oldVehicle === null || oldVehicle === void 0 ? void 0 :
                oldVehicle.make,
                ", ", oldVehicle === null || oldVehicle === void 0 ? void 0 :
                oldVehicle.model,
                " ",
                (oldVehicle === null || oldVehicle === void 0 ? void 0 : oldVehicle.registrationNumber) ? "(".concat(oldVehicle === null || oldVehicle === void 0 ? void 0 : oldVehicle.registrationNumber, ")") : "",
                " with ",
                " ", newVehicle === null || newVehicle === void 0 ? void 0 :
                newVehicle.make,
                ", ", newVehicle === null || newVehicle === void 0 ? void 0 :
                newVehicle.model,
                " ",
                (newVehicle === null || newVehicle === void 0 ? void 0 : newVehicle.registrationNumber) ? "(".concat(newVehicle === null || newVehicle === void 0 ? void 0 : newVehicle.registrationNumber, ")") : "",
                " ",
                tierChangeWording),
            React.createElement("p", { className: "text-align-center font-weight-light font-weight-400" }, "All figures include Insurance Premium Tax")));
    };
    AnnualMotorRenewalReplaceCarPriceWidget.prototype.renderInputField = function () { };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], AnnualMotorRenewalReplaceCarPriceWidget.prototype, "customerPortalService", void 0);
    return AnnualMotorRenewalReplaceCarPriceWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
//# sourceMappingURL=AnnualMotorRenewalReplaceCarPriceWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/renewal/car/AnnualMotorRenewalReplaceCarPriceWidget.js
// module id = 3195
// module chunks = 0